import {
  Button,
  Card,
  Col,
  Form,
  Input,
  notification,
  Row,
  Select,
  Table,
} from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getTempEngagementFormData,
  getUserList,
  getUserInfo,
  getLiveConversionRate,
} from "redux/selectors";
import styled from "styled-components";
import { Required } from "./index.js";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min.js";
import queryKeys from "common/queryKey.js";
import { useFetch } from "hooks/useFetch.js";
import { sumBy } from "lodash";
import { billingOffice } from "common/Constants";
import ResourcePlan from "../EngagementView/ResourcePlan.js";
import SubContractor from "../SubContractor/index.js";
import { currencyAmount } from "utils/functions.js";
import { useMutate } from "hooks/useMutate";
import currencyMasterData from "common/currencyRateMasterData.json";
import { CALL_FEATCH_API } from "common/API.js";
import { setCurrencyList, setLiveConversionRate } from "redux/actions.js";

const labelStyle = {
  width: "150px",
  display: "inline-block",
  textAlign: "start",
};

const FinancialResourcePlanFields = ({
  update,
  setDeletedbookedUserId,
  disabled,
  addResourceandSubDisabled,
  localAddresourceDisable,
  tabId,
  setIsResource,
  isResource,
}) => {
  const form = Form.useFormInstance();
  const history = useHistory();
  const dispatch = useDispatch();
  const tempEngagementFormData = useSelector((state) =>
    getTempEngagementFormData(state)
  );
  const userList = useSelector((state) => getUserList(state));
  const [budjetChargeout, setBudjetChargeout] = useState(0);
  const [showSubContractorModal, setShowSubContractorModal] = useState(false);
  const [onchange, setOnchange] = useState(false);
  const [plannedSubcontractor, setPlannedSubcontractor] = useState(0);
  const [currencyValueList, setCurrencyValueList] = useState([]);
  const userInfo = useSelector(getUserInfo);
  const resourceStatus = useSelector((state) => state.common.resourceStatus);
  const currentUserData = userList?.filter(
    (item) => item.userid === userInfo?.userid
  );
  const convertionRate = useSelector(getLiveConversionRate);
  const userCountry = currentUserData[0]?.managingoffice[0];

  useEffect(() => {
    if (
      convertionRate &&
      Number(convertionRate) !==
      Number(form.getFieldValue("conversion_rate"))
    ) {
      form.setFieldsValue({
        conversion_rate: Number(convertionRate),
      });
    }
  }, [convertionRate]);

  const billingOfficeOptions = billingOffice

    .map((office) => {
      return {
        label: office.name,
        value: office.id,
      };
    });

  const currencyOptions = currencyMasterData.map((currency) => {
    return {
      label: currency.TBD_DESC,
      value: currency.TBD_DESC,
    };
  });

  const formValues = form.getFieldsValue(true);

  const handleCurrencyChange = (value) => {
    const rawValue = String(value || "").trim();
    const selectedMaster = (currencyMasterData || []).find((c) => {
      const desc = String(c?.TBD_DESC || "").trim().toLowerCase();
      const id = String(c?.TBD_ID || "").trim().toLowerCase();
      return desc === rawValue.toLowerCase() || id === rawValue.toLowerCase();
    });
    let latestEntry = currencyValueList?.[0] || {};
    const candidates = [];
    if (selectedMaster?.TBD_ID) candidates.push(selectedMaster.TBD_ID.toLowerCase());
    if (selectedMaster?.TBD_DESC) candidates.push(selectedMaster.TBD_DESC.toLowerCase().replace(/\s+/g, "_"));
    candidates.push(rawValue.toLowerCase().replace(/\s+/g, "_"));
    candidates.push(rawValue.toLowerCase());
    latestEntry = Object.fromEntries(
      Object.entries(latestEntry).map(([key, value]) => [key.toLowerCase(), value])
    );
    let dynamicRateFromAPI;
    for (const k of candidates) {
      if (!k) continue;
      if (Object.prototype.hasOwnProperty.call(latestEntry, k)) {
        const v = latestEntry[k];
        if (v !== undefined && v !== null && String(v).trim() !== "") {
          dynamicRateFromAPI = v;
          break;
        }
      }
    }
    const conversionRateFromMaster = selectedMaster?.TBD_ABBR;
    const finalRate = Number(dynamicRateFromAPI ?? conversionRateFromMaster ?? 1);
    const safeFinalRate = Number.isFinite(finalRate) ? finalRate : 1;
    form.setFieldsValue({ conversion_rate: safeFinalRate });
    dispatch(setLiveConversionRate(safeFinalRate));
    const billingAmount = Number(form.getFieldValue("billing_amount") || 0);
    const plannedFeeAdjustment = Number(form.getFieldValue("planned_fee_adjustment") || 0);
    convertToUSD(billingAmount, safeFinalRate, "usd_amount");
    convertToUSD(plannedFeeAdjustment, safeFinalRate, "pfa_usd");
  };

  const handleBillingAmountChange = async (e) => {
    setOnchange(true);
    const billingAmount = e.target.value;
    const conversionRate = form.getFieldValue("conversion_rate");
    convertToUSD(billingAmount, conversionRate, "usd_amount");
    if (onchange) {
      await profitCals();
    }
  };

  const handleConversionRateChange = async (e) => {
    setOnchange(true);
    const conversionRate = e.target.value;
    dispatch(setLiveConversionRate(conversionRate));
    const billingAmount = form.getFieldValue("billing_amount");
    const plannedFeeAdjustment = form.getFieldValue("planned_fee_adjustment");

    convertToUSD(billingAmount, conversionRate, "usd_amount");
    convertToUSD(plannedFeeAdjustment, conversionRate, "pfa_usd");
    if (onchange) {
      await profitCals();
    }
  };

  const convertToUSD = (amount, conversionRate, targetField) => {
    if (amount && conversionRate) {
      const usdAmount = parseFloat(amount) * parseFloat(conversionRate);
      form.setFieldsValue({ [targetField]: Number(usdAmount.toFixed(2)) });
    } else {
      form.setFieldsValue({ [targetField]: "" });
    }
  };

  const pfaStatusOptions = [
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
    { label: "Closed", value: "closed" },
  ];

  const { id } = useParams();

  const [profitLoss, setProfitLoss] = useState(0);
  const {
    getEngagementById,
    getBillingById,
    getTimeSheetByengagementId,
    addEngagement: addEngagementQuery,
  } = queryKeys;

  const { key: addEngagementKey, url: addEngagementUrl } =
    addEngagementQuery(true);

  const { mutate: addEngagement, isLoading: isPosting } = useMutate(
    addEngagementKey,
    addEngagementUrl
  );

  const { key, url } = getEngagementById(id);

  const { data: engagementDataRes, refetch: engagementRefetch } = useFetch(
    key,
    url,
    {
      enabled: !!id,
    }
  );

  const engagementData = engagementDataRes?.data;
  const enableIfActiveAndStakeHolder = () => {
    if (disabled) {
      const engagementStatus = engagementData?.jobCloser?.status;

      // const userDetails = userList.find(
      //   (val) => val?.userid === userInfo?.userid
      // );

      // const userManaginOffice = userDetails?.managingoffice?.[0];

      const isPartnerOrManagerOrHeadOfficeUser =
        userInfo?.userid === engagementData?.stakeHolder?.personIncharge ||
        userInfo?.userid === engagementData?.stakeHolder?.partner || userInfo?.roleId === "8";
      //|| userManaginOffice === "Head Office";

      const isEngagementActive = engagementStatus === "Active";

      return update
        ? !(isPartnerOrManagerOrHeadOfficeUser && isEngagementActive)
        : false;
    }
    return false;
  };

  const currencyDisable = enableIfActiveAndStakeHolder();

  useEffect(() => {
    let data =
      engagementData?.employeeList ?? tempEngagementFormData?.resourceList ?? [];
    const total = sumBy(data, (item) =>
      isNaN(parseFloat(item?.personDay)) ? 0 : parseFloat(item.personDay)
    );
    form.setFieldsValue({ mandays: total || 0 });
    let subcontractorData =
      engagementData?.subcontractor ?? tempEngagementFormData?.subcontractList ?? [];

    const sumSubContractamt = sumBy(subcontractorData, (item) =>
      isNaN(parseFloat(item?.amount)) ? 0 : parseFloat(item?.amount)
    );
    form.setFieldsValue({ subcontractor_usd: sumSubContractamt || 0 });
    const budjetChargeout = (data || [])
      .filter((item) => {
        const resourceExtRate = parseFloat(item?.resourceExtRate);
        return !isNaN(resourceExtRate) && !isNaN(parseFloat(item?.personDay));
      })
      .map((item) => parseFloat(item?.resourceExtRate) * (parseFloat(item?.personDay) || 0) * 8)
      .reduce((acc, value) => acc + value, 0);
    // setBudjetChargeout(budjetChargeout || 0);
    setPlannedSubcontractor(sumSubContractamt || 0);
  }, [engagementData, tempEngagementFormData]);


  const { key: billingKey, url: billingUrl } = getBillingById(id);
  const { key: timesheetKey, url: timesheetUrl } =
    getTimeSheetByengagementId(id);

  const { data: billingList } = useFetch(billingKey, billingUrl, {
    enabled: !!id,
  });

  const { data: timeSheetList } = useFetch(timesheetKey, timesheetUrl, {
    enabled: !!id,
  });

  const billingData = useMemo(() => {
    return billingList?.response?.items ?? [];
  }, [billingList]);

  const timeSheetData = useMemo(() => {
    return timeSheetList?.response?.response ?? [];
  }, [timeSheetList]);

  async function profitCals() {
    const profitLossCal =
      parseFloat(typeof formValues?.usd_amount === 'string' ? formValues?.usd_amount?.replace(/,/g, '') : formValues?.usd_amount || 0) -
      (parseInt(budjetChargeout) + parseInt(plannedSubcontractor));
    const conversionRate = form.getFieldValue("conversion_rate");
    form.setFieldsValue({
      planned_fee_adjustment:
        profitLossCal < 0 ? Math.abs(profitLossCal) : "0.00",
    });
    form.setFieldsValue({
      pfa_usd: profitLossCal < 0 ? Math.abs(profitLossCal) : "0.00",
    });
    const pfastatus = profitLossCal < 0 ? "Not Approved" : "Not Applicable";
    if (
      parseInt(engagementData?.financial_resourcePlan?.billingAmount) !==
      parseFloat(typeof formValues?.usd_amount === 'string' ? formValues?.usd_amount?.replace(/,/g, '') : formValues?.usd_amount || 0)
    ) {
      if (onchange) {
        form.setFieldsValue({
          pfa_status: pfastatus,
        });
      }
      let jobclosurestatus;
      if (pfastatus === "Not Approved") {
        jobclosurestatus = "Not Approved";
      } else if (pfastatus === "Not Applicable") {
        jobclosurestatus = "Not Started";
      } else {
        jobclosurestatus = engagementData?.jobCloser?.status || "Active";
      }
      form.setFieldsValue({
        ...form.getFieldsValue(true),
        status: form.getFieldValue("status") === "Closed"
          ? "Closed"
          : jobclosurestatus,
      });
    }
    if (isResource || resourceStatus) {
      form.setFieldsValue({ pfa_status: pfastatus });
      let jobclosurestatus;
      if (pfastatus === "Not Approved") {
        jobclosurestatus = "Not Approved";
      } else if (pfastatus === "Not Applicable") {
        jobclosurestatus = "Not Started";
      } else {
        jobclosurestatus = engagementData?.jobCloser?.status || "Active";
      }
      form.setFieldsValue({
        ...form.getFieldsValue(true),
        status: form.getFieldValue("status") === "Closed"
          ? "Closed"
          : jobclosurestatus,
      });
    }
    setProfitLoss(profitLossCal);
    setOnchange(false);
  }

  useEffect(() => {
    profitCals();
    if (!update) {
      const pfastatus = profitLoss < 0 ? "Not Approved" : "Not Applicable";
      let jobclosurestatus;
      if (pfastatus === "Not Approved") {
        jobclosurestatus = "Not Approved";
      } else if (pfastatus === "Not Applicable") {
        jobclosurestatus = "Not Started";
      } else {
        jobclosurestatus = "Not Started";
      }
      form.setFieldsValue({
        ...form.getFieldsValue(true),
        status: form.getFieldValue("status") === "Closed"
          ? "Closed"
          : jobclosurestatus,
      });
      if (tempEngagementFormData) {
        tempEngagementFormData.pfa_status = pfastatus;
        tempEngagementFormData.status =
          form.getFieldValue("status") === "Closed"
            ? "Closed"
            : jobclosurestatus;
      } else {
        console.error(
          "tempEngagementFormData is not an object:",
          tempEngagementFormData
        );
      }
    }
  }, [
    billingData,
    timeSheetData,
    engagementData,
    budjetChargeout,
    plannedSubcontractor,
    formValues,
  ]);

  const yearRangeOptions = [];
  const startYear = 2000; // Adjust as needed
  const endYear = new Date().getFullYear() + 1;

  for (let year = startYear; year < endYear; year++) {
    yearRangeOptions.push({
      label: `${year}-${year + 1}`,
      value: `${year}-${year + 1}`,
    });
  }

  const handleAddResource = () => {
    const planStartDate = formValues?.plan_start_date;
    const planEndDate = formValues?.plan_end_date;
    const personIncharge = formValues?.person_incharge;
    const partner = formValues?.partner;

    if (planStartDate && planEndDate && personIncharge && partner) {
      history.push(`/engagement/${engagementData?.engagementId ?? tempEngagementFormData?.engagement_id}/add-resources`);
    } else {
      notification.error({
        message:
          "Please Select Person In charge, Partner,  Plan Start Date and Plan End Date",
      });
    }
  };

  const handleShowSubcontractorModal = () => {
    const planStartDate = formValues?.plan_start_date;
    const planEndDate = formValues?.plan_end_date;
    const personIncharge = formValues?.person_incharge;
    const partner = formValues?.partner;

    if (planStartDate && planEndDate && personIncharge && partner) {
      setShowSubContractorModal(true);
    } else {
      notification.error({
        message:
          "Please Select Person In charge, Partner,  Plan Start Date and Plan End Date",
      });
    }
  };

  const selectedPartnerName = userList?.find((user) => {
    return (
      user.userid === tempEngagementFormData?.partner ??
      engagementData?.stakeHolder?.partner ??
      null
    );
  });

  let clientName = form.getFieldValue("client_name");

  const engagementApprovalSendEmail = () => {
    const sendEmailData = {
      managingPartner: selectedPartnerName
        ? selectedPartnerName?.firstname + " " + selectedPartnerName?.lastname
        : null,
      clientName: engagementData?.client?.clientName ?? clientName ?? null,
      emailId:
        engagementData?.stakeHolder?.partner ??
        tempEngagementFormData?.partner ??
        null,
    };
    addEngagement(sendEmailData, {
      onSuccess: (res) => {
        notification.success({
          message: "Email Sent Successfully",
        });
      },
    });
  };

  const handleKeyDown = (e) => {
    const { key } = e;
    if (!/^\d$/.test(key) && key !== "Backspace" && key !== ".") {
      e.preventDefault();
    }
  };

  useEffect(() => {
    let usdAmount = form.getFieldValue("usd_amount");
    if (!usdAmount) {
      form.setFieldValue("usd_amount", "0");
    } else {
      if (typeof usdAmount === "string") {
        usdAmount = usdAmount.replace(/,/g, "");
      }
      const parsedAmount = Number(usdAmount);
      if (!isNaN(parsedAmount)) {
        const formatted = currencyAmount("USD", parsedAmount).replace("USD", "");
        form.setFieldValue("usd_amount", formatted);
      } else {
        form.setFieldValue("usd_amount", "0");
      }
    }
    if (update) {
      form.setFieldValue(
        "billing_office",
        engagementData?.financial_resourcePlan?.billingOffice
      );
    }
  }, []);

  useEffect(() => {
    // if (update) {
    form.setFieldValue(
      "billing_office",
      tempEngagementFormData?.billing_office ??
      engagementData?.financial_resourcePlan?.billingOffice
    );
    // }
  }, [update, engagementData, tempEngagementFormData, tabId]);

  useEffect(() => {
    const fetchCurrencyValues = async () => {
      try {
        const response = await CALL_FEATCH_API('insyts/timesheet/currencylist', 'get');
        const currencyResponse = response?.response?.data || [];
        setCurrencyValueList(currencyResponse);
        dispatch(setCurrencyList(currencyResponse));
      } catch (error) {
        console.error("Currency list fetch failed:", error);
      }
    };

    fetchCurrencyValues();
  }, []);

  return (
    <FinancialWrap>
      <Card className="fields-card">
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label={
                <span style={labelStyle}>
                  Billing Entity <Required />
                </span>
              }
              name="billing_office"
              rules={[
                { required: true, message: "Please select billing Entity!" },
              ]}
            >
              <Select
                placeholder="Select"
                showSearch={true}
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  )
                }
                options={billingOfficeOptions}
                disabled={
                  (userInfo?.userid ===
                    engagementData?.stakeHolder?.personIncharge &&
                    engagementData?.jobCloser?.status === "Active") || userInfo?.roleId === "8"
                    ? false
                    : disabled
                }
              />
            </Form.Item>

            <Form.Item
              label={
                <span style={labelStyle}>
                  Financial Year <Required />
                </span>
              }
              name="financial_year"
            // rules={[
            //   { required: true, message: "Please select financial year!" },
            // ]}
            >
              {/* <DatePicker picker="year" style={{ width: "100%" }} placeholder="Select" /> */}
              {/* <Select
                placeholder="Select Financial Year"
                options={yearRangeOptions.reverse()}
                style={{ width: "100%" }}
              /> */}
              <Input placeholder="Enter" disabled />
            </Form.Item>

            <Form.Item
              label={<span style={labelStyle}>Mandays</span>}
              name="mandays"
            >
              <Input placeholder="Enter" disabled />
            </Form.Item>

            <Form.Item
              label={<span style={labelStyle}>Currency</span>}
              name="currency"
            >
              <Select
                placeholder="Select"
                options={currencyOptions}
                showSearch={true}
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  )
                }
                onChange={handleCurrencyChange}
                disabled={currencyDisable}
              />
            </Form.Item>

            <Form.Item
              label={<span style={labelStyle}>Local Currency Amount</span>}
              name="billing_amount"
            >
              <Input
                placeholder="Enter"
                onChange={handleBillingAmountChange}
                disabled={localAddresourceDisable || engagementData?.jobCloser?.status === "Closed"}
                onKeyDown={handleKeyDown}
              />
            </Form.Item>
            {/* <Form.Item
              label={<span style={labelStyle}>Conversion rate</span>}
              name="conversion_rate"
            >
              <Input
                placeholder="Enter"
                onChange={handleConversionRateChange}
                disabled={addResourceandSubDisabled || engagementData?.jobCloser?.status === "Closed"}
                onKeyDown={handleKeyDown}
              />
            </Form.Item> */}
            <Form.Item shouldUpdate>
              {({ getFieldValue }) => (
                <Form.Item
                  label={<span style={labelStyle}>Conversion rate</span>}
                  name="conversion_rate"
                >
                  <Input
                    placeholder="Enter"
                    onChange={handleConversionRateChange}
                    disabled={!!getFieldValue("conversion_rate") || addResourceandSubDisabled || engagementData?.jobCloser?.status === "Closed"}
                    onKeyDown={handleKeyDown}
                  />
                </Form.Item>
              )}
            </Form.Item>
            <Form.Item
              label={<span style={labelStyle}>USD Amount</span>}
              name="usd_amount"
            >
              <Input placeholder="Enter" disabled={true} />
            </Form.Item>
            {/* 
          <Form.Item label={<span style={labelStyle}>Planned Fee Adjustment</span>} name="planned_fee_adjustment">
            <Input placeholder="Enter" disabled />
          </Form.Item>

          <Form.Item label={<span style={labelStyle}>PFA USD</span>} name="pfa_usd">
            <Input placeholder="Enter" disabled={true} />
          </Form.Item> 
            <Form.Item name="usd_amount" style={{ display: "none" }}>
              <Input type="hidden" />
            </Form.Item>
            */}

            <Form.Item
              name="planned_fee_adjustment"
              style={{ display: "none" }}
            >
              <Input type="hidden" />
            </Form.Item>

            <Form.Item name="pfa_usd" style={{ display: "none" }}>
              <Input type="hidden" />
            </Form.Item>

            <div className="d-flex align-items-start gap-2">
              <Form.Item
                label={<span style={labelStyle}>PFA Status</span>}
                name="pfa_status"
                className="w-100"
              >
                {/* <Select
                  placeholder="Select"
                  options={pfaStatusOptions}
                  disabled
                /> */}
                <Input placeholder="Enter" disabled={true} />
              </Form.Item>
              {profitLoss < 0 && (
                <Button
                  type="primary"
                  loading={isPosting}
                  onClick={() => {
                    engagementApprovalSendEmail();
                  }}
                  disabled={form.getFieldValue("pfa_status") === "Approved"}
                >
                  Get Approval
                </Button>
              )}
            </div>

            <Form.Item
              style={{ display: "none" }}
              label={<span style={labelStyle}>Subcontractor USD</span>}
              name="subcontractor_usd"
            >
              <Input placeholder="Enter" type="hidden" disabled={true} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <StyleTable
              bordered
              columns={[
                { title: "Summary", dataIndex: "summary", key: "summary" },
                {
                  title: "Budget(USD)",
                  dataIndex: "manday_fee",
                  key: "manday_fee",
                  className: "align-right",
                },
              ]}
              dataSource={[
                {
                  key: "1",
                  summary: "Total Mandays",
                  manday_fee: formValues?.mandays || "0",
                },
                {
                  key: "2",
                  summary: "Billing Amount(USD)",
                  manday_fee:
                    currencyAmount("$", parseFloat(typeof formValues?.usd_amount === 'string' ? formValues?.usd_amount?.replace(/,/g, '') : formValues?.usd_amount || 0)) ||
                    currencyAmount("$", 0),
                },
                {
                  key: "3",
                  summary: "Planned Chargeout",
                  manday_fee:
                    currencyAmount("$", budjetChargeout) ||
                    currencyAmount("$", 0),
                },
                {
                  key: "4",
                  summary: "Planned Subcontractor",
                  manday_fee:
                    currencyAmount("$", parseInt(plannedSubcontractor)) ||
                    currencyAmount("$", 0),
                },
                {
                  key: "5",
                  summary: "Estimated Profit",
                  manday_fee: (
                    <span style={{ color: profitLoss < 0 ? "red" : "black" }}>
                      {((budjetChargeout > 0 || plannedSubcontractor > 0) &&
                        currencyAmount("$", profitLoss)) ||
                        currencyAmount("$", 0)}
                    </span>
                  ),
                },
                {
                  key: "6",
                  summary: "PFA(Planned fee Adjustment)",
                  manday_fee:
                    profitLoss < 0
                      ? currencyAmount("$", Math.abs(profitLoss))
                      : currencyAmount("$", 0),
                },
                {
                  key: "7",
                  summary: "Profit - after PFA",
                  manday_fee:
                    (budjetChargeout > 0 || plannedSubcontractor > 0) &&
                      profitLoss > 0
                      ? currencyAmount("$", Math.abs(profitLoss))
                      : currencyAmount("$", 0),
                },
              ]}
              pagination={false}
            />
          </Col>
        </Row>
      </Card>

      <div className="mt-3">
        {!localAddresourceDisable && (
          <div className="btns">
            <Button
              type="primary"
              className="add-resource-btn"
              onClick={handleAddResource}
              disabled={localAddresourceDisable || engagementData?.jobCloser?.status === "Closed"}
            >
              Add Resources
            </Button>

            <Button
              type="primary"
              className="add-subcontractor-btn"
              onClick={handleShowSubcontractorModal}
              disabled={localAddresourceDisable || engagementData?.jobCloser?.status === "Closed"}
            >
              Add Subcontractor
            </Button>
          </div>
        )}
        <ResourcePlan
          engagementData={engagementData}
          tempEngagementFormData={tempEngagementFormData}
          engagementRefetch={engagementRefetch}
          update={update}
          setDeletedbookedUserId={setDeletedbookedUserId}
          addResourceandSubDisabled={addResourceandSubDisabled}
          localAddresourceDisable={localAddresourceDisable}
          setBudjetChargeout={setBudjetChargeout}
          setIsResource={setIsResource}
        />
        <SubContractor
          engagementData={engagementData}
          setShowAddModal={setShowSubContractorModal}
          showAddModal={showSubContractorModal}
          tempEngagementFormData={tempEngagementFormData}
          engagementRefetch={engagementRefetch}
        />
      </div>
    </FinancialWrap>
  );
};
export default FinancialResourcePlanFields;

const FinancialWrap = styled.div`
  .btns {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
  }

  .add-resource-btn,
  .add-subcontractor-btn {
    border-radius: 5px;
  }

  .ant-select-selector {
    cursor: pointer !important;
  }
`;

const StyleTable = styled(Table)`
  .ant-table-thead > tr > th {
    background-color: #dbdbdb;
    font-weight: 700;
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #dbdbdb;
  }
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table
    > thead
    > tr
    > th {
    border-right: 1px solid #dbdbdb;
  }
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table
    > tbody
    > tr
    > td {
    border-right: 1px solid #dbdbdb;
  }
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table {
    border-top: 1px solid #dbdbdb;
  }
  .ant-table.ant-table-bordered > .ant-table-container {
    border-left: 1px solid #dbdbdb;
  }
  .ant-table-cell {
    padding: 6px 12px;
    font-size: 16px;
    font-weight: 500;
  }
  .ant-table-container {
    border-radius: 5px;
  }
  .ant-table {
    border-radius: 5px;
  }
  .align-right {
    text-align: right;
  }
`;